/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 3.2.1263 on 2024-10-29 16:54:22.

export interface CreateSavedCardRequest {
    cardId: string;
    gatewayId: string;
    lastFourDigits: string;
    cardType: string;
    expirationMonth: string;
    expirationYear: string;
}

export interface CreateTransactionRecipientRequest {
    firstName: string;
    lastName: string;
    middleName: string;
    parentName: string;
    countryCode: string;
    residence: string;
    phoneNumber: string;
    recipientCountry: string;
    additionalField1: string;
    additionalField2: string;
    additionalField3: string;
}

export interface DeleteRequest {
    id: string;
}

export interface UpdateTransactionRecipientRequest {
    id: string;
    firstName: string;
    lastName: string;
    middleName: string;
    parentName: string;
    countryCode: string;
    residence: string;
    phoneNumber: string;
    recipientCountry: string;
}

export interface UpdateTransactionRecipientRequestDto extends RequestHeaderInfoDtoBase {
    id: string;
    firstName: string;
    lastName: string;
    middleName: string;
    parentName: string;
    countryCode: string;
    residence: string;
    phoneNumber: string;
    recipientCountry: string;
    additionalField1: string;
    additionalField2: string;
    additionalField3: string;
}

export interface WebResponseEntity<T> {
    result: T; problemResponseData?: ProblemResponseData|null;
}

export interface SavedCardResponseDto {
    id: string;
    cardId: string;
    gatewayId: string;
    lastFourDigits: string;
    cardType: string;
    createdAt: DateAsString;
    lastUpdatedAt: DateAsString;
    isActive: boolean;
    expirationYear: string;
    expirationMonth: string;
}

export interface WebListResponseEntity<T> {
    result: T[]; problemResponseData?: ProblemResponseData|null;
}

export interface TransactionRecipientResponseDto {
    id: string;
    firstName: string;
    lastName: string;
    middleName: string;
    parentName: string;
    countryCode: string;
    residence: string;
    phoneNumber: string;
    recipientCountry: string;
    additionalField1: string;
    additionalField2: string;
    additionalField3: string;
    createdAt: DateAsString;
    lastUpdatedAt: DateAsString;
    isActive: boolean;
}

export interface RequestHeaderBaseInfo {
    userType: RequestUserType;
    appInfo: RequestApplicationInfo;
    masterAgentInfo: RequestMasterAgentInfo;
    userInfo: RequestUserInfo;
    agentInfo: RequestAgentInfo;
    merchantInfo: RequestMerchantInfo;
}

export interface RequestHeaderInfoDtoBase {
    requestHeaderInfo: RequestHeaderBaseInfo;
}

export interface WebResponseObject<T> extends WebResponseBase {
    result: T;
}

export interface RequestApplicationInfo extends RequestInfo {
    serviceRequest: boolean;
    applicationId: string;
    language: string;
}

export interface RequestMasterAgentInfo extends RequestInfo {
    masterAgentAccessId: string;
    country: string;
}

export interface RequestUserInfo extends RequestInfo {
    userId: string;
    requestPermission: number;
    subservicePermission: number;
}

export interface RequestAgentInfo extends RequestInfo {
    terminalId: string;
    locationId: string;
    agentId: string;
}

export interface RequestMerchantInfo extends RequestInfo {
    merchantId: string;
}

export interface ProblemResponseData extends Serializable {
    error: boolean;
    problems: ProblemBase[];
}

export interface WebResponseBase extends Serializable {
    problemResponseData: ProblemResponseData;
}

export interface ResponseEntity<T> {
    result: T;
    problemResponseData?: ProblemResponseData|null;
}

export interface RequestInfo {
}

export interface ProblemBase extends Serializable {
    problemCode: number;
    applicationOrigin: string;
    exceptionCode: string;
    message: string;
    details: string;
    type: string;
}

export interface Serializable {
}

export interface HttpEntity<T> {
    headers: { [index: string]: string[] };
    body: T;
}

export interface HttpClient<O> {

    request<R>(requestConfig: { method: string; url: string; queryParams?: any; data?: any; copyFn?: (data: R) => R; options?: O; }): RestResponse<R>;
}

export class RestApplicationClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP POST /web-wks/saved-card/create
     * Java method: com.europoint.webclientsworkspace.webclientsworkspaceapp.web.SavedCardController.createSavedCard
     */
    createSavedCard(req: CreateSavedCardRequest, options?: O): RestResponse<WebResponseEntity<SavedCardResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`web-wks/saved-card/create`, data: req, options: options });
    }

    /**
     * HTTP POST /web-wks/saved-card/delete
     * Java method: com.europoint.webclientsworkspace.webclientsworkspaceapp.web.SavedCardController.deleteSavedCard
     */
    deleteSavedCard(request: DeleteRequest, options?: O): RestResponse<WebResponseEntity<SavedCardResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`web-wks/saved-card/delete`, data: request, options: options });
    }

    /**
     * HTTP GET /web-wks/saved-card/get-saved-card-by-id
     * Java method: com.europoint.webclientsworkspace.webclientsworkspaceapp.web.SavedCardController.getSavedCardById
     */
    getSavedCardById(queryParams: { cardId: string; }, options?: O): RestResponse<WebResponseEntity<SavedCardResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`web-wks/saved-card/get-saved-card-by-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /web-wks/saved-card/get-saved-cards-by-user-id
     * Java method: com.europoint.webclientsworkspace.webclientsworkspaceapp.web.SavedCardController.getSavedCardsByUserId
     */
    getSavedCardsByUserId(queryParams: { onlyActive: boolean; }, options?: O): RestResponse<WebListResponseEntity<SavedCardResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`web-wks/saved-card/get-saved-cards-by-user-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /web-wks/transaction-recipient/create
     * Java method: com.europoint.webclientsworkspace.webclientsworkspaceapp.web.TransactionRecipientController.createTransactionRecipient
     */
    createTransactionRecipient(req: CreateTransactionRecipientRequest, options?: O): RestResponse<WebResponseEntity<TransactionRecipientResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`web-wks/transaction-recipient/create`, data: req, options: options });
    }

    /**
     * HTTP POST /web-wks/transaction-recipient/delete
     * Java method: com.europoint.webclientsworkspace.webclientsworkspaceapp.web.TransactionRecipientController.deleteTransactionRecipient
     */
    deleteTransactionRecipient(request: DeleteRequest, options?: O): RestResponse<WebResponseEntity<TransactionRecipientResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`web-wks/transaction-recipient/delete`, data: request, options: options });
    }

    /**
     * HTTP GET /web-wks/transaction-recipient/get-transaction-recipient-by-id
     * Java method: com.europoint.webclientsworkspace.webclientsworkspaceapp.web.TransactionRecipientController.getTransactionRecipientById
     */
    getTransactionRecipientById(queryParams: { id: string; }, options?: O): RestResponse<WebResponseEntity<TransactionRecipientResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`web-wks/transaction-recipient/get-transaction-recipient-by-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /web-wks/transaction-recipient/get-transaction-recipients-by-user-id
     * Java method: com.europoint.webclientsworkspace.webclientsworkspaceapp.web.TransactionRecipientController.getTransactionRecipientsByUserId
     */
    getTransactionRecipientsByUserId(queryParams: { onlyActive: boolean; }, options?: O): RestResponse<WebListResponseEntity<TransactionRecipientResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`web-wks/transaction-recipient/get-transaction-recipients-by-user-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /web-wks/transaction-recipient/update
     * Java method: com.europoint.webclientsworkspace.webclientsworkspaceapp.web.TransactionRecipientController.updateTransactionRecipient
     */
    updateTransactionRecipient(req: UpdateTransactionRecipientRequestDto, options?: O): RestResponse<WebResponseEntity<TransactionRecipientResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`web-wks/transaction-recipient/update`, data: req, options: options });
    }
}

export type RestResponse<R> = Promise<Axios.GenericAxiosResponse<R>>;

export type DateAsString = string;

/**
 * Values:
 * - `CONTINUE`
 * - `SWITCHING_PROTOCOLS`
 * - `PROCESSING`
 * - `CHECKPOINT`
 * - `OK`
 * - `CREATED`
 * - `ACCEPTED`
 * - `NON_AUTHORITATIVE_INFORMATION`
 * - `NO_CONTENT`
 * - `RESET_CONTENT`
 * - `PARTIAL_CONTENT`
 * - `MULTI_STATUS`
 * - `ALREADY_REPORTED`
 * - `IM_USED`
 * - `MULTIPLE_CHOICES`
 * - `MOVED_PERMANENTLY`
 * - `FOUND`
 * - `MOVED_TEMPORARILY` - @deprecated
 * - `SEE_OTHER`
 * - `NOT_MODIFIED`
 * - `USE_PROXY` - @deprecated
 * - `TEMPORARY_REDIRECT`
 * - `PERMANENT_REDIRECT`
 * - `BAD_REQUEST`
 * - `UNAUTHORIZED`
 * - `PAYMENT_REQUIRED`
 * - `FORBIDDEN`
 * - `NOT_FOUND`
 * - `METHOD_NOT_ALLOWED`
 * - `NOT_ACCEPTABLE`
 * - `PROXY_AUTHENTICATION_REQUIRED`
 * - `REQUEST_TIMEOUT`
 * - `CONFLICT`
 * - `GONE`
 * - `LENGTH_REQUIRED`
 * - `PRECONDITION_FAILED`
 * - `PAYLOAD_TOO_LARGE`
 * - `REQUEST_ENTITY_TOO_LARGE` - @deprecated
 * - `URI_TOO_LONG`
 * - `REQUEST_URI_TOO_LONG` - @deprecated
 * - `UNSUPPORTED_MEDIA_TYPE`
 * - `REQUESTED_RANGE_NOT_SATISFIABLE`
 * - `EXPECTATION_FAILED`
 * - `I_AM_A_TEAPOT`
 * - `INSUFFICIENT_SPACE_ON_RESOURCE` - @deprecated
 * - `METHOD_FAILURE` - @deprecated
 * - `DESTINATION_LOCKED` - @deprecated
 * - `UNPROCESSABLE_ENTITY`
 * - `LOCKED`
 * - `FAILED_DEPENDENCY`
 * - `TOO_EARLY`
 * - `UPGRADE_REQUIRED`
 * - `PRECONDITION_REQUIRED`
 * - `TOO_MANY_REQUESTS`
 * - `REQUEST_HEADER_FIELDS_TOO_LARGE`
 * - `UNAVAILABLE_FOR_LEGAL_REASONS`
 * - `INTERNAL_SERVER_ERROR`
 * - `NOT_IMPLEMENTED`
 * - `BAD_GATEWAY`
 * - `SERVICE_UNAVAILABLE`
 * - `GATEWAY_TIMEOUT`
 * - `HTTP_VERSION_NOT_SUPPORTED`
 * - `VARIANT_ALSO_NEGOTIATES`
 * - `INSUFFICIENT_STORAGE`
 * - `LOOP_DETECTED`
 * - `BANDWIDTH_LIMIT_EXCEEDED`
 * - `NOT_EXTENDED`
 * - `NETWORK_AUTHENTICATION_REQUIRED`
 */
export const enum HttpStatus {
    CONTINUE = "CONTINUE",
    SWITCHING_PROTOCOLS = "SWITCHING_PROTOCOLS",
    PROCESSING = "PROCESSING",
    CHECKPOINT = "CHECKPOINT",
    OK = "OK",
    CREATED = "CREATED",
    ACCEPTED = "ACCEPTED",
    NON_AUTHORITATIVE_INFORMATION = "NON_AUTHORITATIVE_INFORMATION",
    NO_CONTENT = "NO_CONTENT",
    RESET_CONTENT = "RESET_CONTENT",
    PARTIAL_CONTENT = "PARTIAL_CONTENT",
    MULTI_STATUS = "MULTI_STATUS",
    ALREADY_REPORTED = "ALREADY_REPORTED",
    IM_USED = "IM_USED",
    MULTIPLE_CHOICES = "MULTIPLE_CHOICES",
    MOVED_PERMANENTLY = "MOVED_PERMANENTLY",
    FOUND = "FOUND",
    /**
     * @deprecated
     */
    MOVED_TEMPORARILY = "MOVED_TEMPORARILY",
    SEE_OTHER = "SEE_OTHER",
    NOT_MODIFIED = "NOT_MODIFIED",
    /**
     * @deprecated
     */
    USE_PROXY = "USE_PROXY",
    TEMPORARY_REDIRECT = "TEMPORARY_REDIRECT",
    PERMANENT_REDIRECT = "PERMANENT_REDIRECT",
    BAD_REQUEST = "BAD_REQUEST",
    UNAUTHORIZED = "UNAUTHORIZED",
    PAYMENT_REQUIRED = "PAYMENT_REQUIRED",
    FORBIDDEN = "FORBIDDEN",
    NOT_FOUND = "NOT_FOUND",
    METHOD_NOT_ALLOWED = "METHOD_NOT_ALLOWED",
    NOT_ACCEPTABLE = "NOT_ACCEPTABLE",
    PROXY_AUTHENTICATION_REQUIRED = "PROXY_AUTHENTICATION_REQUIRED",
    REQUEST_TIMEOUT = "REQUEST_TIMEOUT",
    CONFLICT = "CONFLICT",
    GONE = "GONE",
    LENGTH_REQUIRED = "LENGTH_REQUIRED",
    PRECONDITION_FAILED = "PRECONDITION_FAILED",
    PAYLOAD_TOO_LARGE = "PAYLOAD_TOO_LARGE",
    /**
     * @deprecated
     */
    REQUEST_ENTITY_TOO_LARGE = "REQUEST_ENTITY_TOO_LARGE",
    URI_TOO_LONG = "URI_TOO_LONG",
    /**
     * @deprecated
     */
    REQUEST_URI_TOO_LONG = "REQUEST_URI_TOO_LONG",
    UNSUPPORTED_MEDIA_TYPE = "UNSUPPORTED_MEDIA_TYPE",
    REQUESTED_RANGE_NOT_SATISFIABLE = "REQUESTED_RANGE_NOT_SATISFIABLE",
    EXPECTATION_FAILED = "EXPECTATION_FAILED",
    I_AM_A_TEAPOT = "I_AM_A_TEAPOT",
    /**
     * @deprecated
     */
    INSUFFICIENT_SPACE_ON_RESOURCE = "INSUFFICIENT_SPACE_ON_RESOURCE",
    /**
     * @deprecated
     */
    METHOD_FAILURE = "METHOD_FAILURE",
    /**
     * @deprecated
     */
    DESTINATION_LOCKED = "DESTINATION_LOCKED",
    UNPROCESSABLE_ENTITY = "UNPROCESSABLE_ENTITY",
    LOCKED = "LOCKED",
    FAILED_DEPENDENCY = "FAILED_DEPENDENCY",
    TOO_EARLY = "TOO_EARLY",
    UPGRADE_REQUIRED = "UPGRADE_REQUIRED",
    PRECONDITION_REQUIRED = "PRECONDITION_REQUIRED",
    TOO_MANY_REQUESTS = "TOO_MANY_REQUESTS",
    REQUEST_HEADER_FIELDS_TOO_LARGE = "REQUEST_HEADER_FIELDS_TOO_LARGE",
    UNAVAILABLE_FOR_LEGAL_REASONS = "UNAVAILABLE_FOR_LEGAL_REASONS",
    INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR",
    NOT_IMPLEMENTED = "NOT_IMPLEMENTED",
    BAD_GATEWAY = "BAD_GATEWAY",
    SERVICE_UNAVAILABLE = "SERVICE_UNAVAILABLE",
    GATEWAY_TIMEOUT = "GATEWAY_TIMEOUT",
    HTTP_VERSION_NOT_SUPPORTED = "HTTP_VERSION_NOT_SUPPORTED",
    VARIANT_ALSO_NEGOTIATES = "VARIANT_ALSO_NEGOTIATES",
    INSUFFICIENT_STORAGE = "INSUFFICIENT_STORAGE",
    LOOP_DETECTED = "LOOP_DETECTED",
    BANDWIDTH_LIMIT_EXCEEDED = "BANDWIDTH_LIMIT_EXCEEDED",
    NOT_EXTENDED = "NOT_EXTENDED",
    NETWORK_AUTHENTICATION_REQUIRED = "NETWORK_AUTHENTICATION_REQUIRED",
}

export const enum RequestUserType {
    Undefined = "Undefined",
    ProviderUser = "ProviderUser",
    MasterAgentUser = "MasterAgentUser",
    MasterAgentService = "MasterAgentService",
    WebMasterAgentUser = "WebMasterAgentUser",
    AgentUser = "AgentUser",
    AgentService = "AgentService",
    WebAgentUser = "WebAgentUser",
    MerchantUser = "MerchantUser",
    MerchantService = "MerchantService",
    WebMerchantUser = "WebMerchantUser",
}

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
    let result = "";
    for (let i = 0; i < substitutions.length; i++) {
        result += template[i];
        result += encodeURIComponent(substitutions[i]);
    }
    result += template[template.length - 1];
    return result;
}


// Added by 'AxiosClientExtension' extension

import axios from "axios";
import * as Axios from "axios";

declare module "axios" {
    export interface GenericAxiosResponse<R> extends Axios.AxiosResponse {
        data: R;
    }
}

class AxiosHttpClient implements HttpClient<Axios.AxiosRequestConfig> {

    constructor(private axios: Axios.AxiosInstance) {
    }

    request<R>(requestConfig: { method: string; url: string; queryParams?: any; data?: any; copyFn?: (data: R) => R; options?: Axios.AxiosRequestConfig; }): RestResponse<R> {
        function assign(target: any, source?: any) {
            if (source != undefined) {
                for (const key in source) {
                    if (source.hasOwnProperty(key)) {
                        target[key] = source[key];
                    }
                }
            }
            return target;
        }

        const config: Axios.AxiosRequestConfig = {};
        config.method = requestConfig.method as typeof config.method;  // `string` in axios 0.16.0, `Method` in axios 0.19.0
        config.url = requestConfig.url;
        config.params = requestConfig.queryParams;
        config.data = requestConfig.data;
        assign(config, requestConfig.options);
        const copyFn = requestConfig.copyFn;

        const axiosResponse = this.axios.request(config);
        return axiosResponse.then(axiosResponse => {
            if (copyFn && axiosResponse.data) {
                (axiosResponse as any).originalData = axiosResponse.data;
                axiosResponse.data = copyFn(axiosResponse.data);
            }
            return axiosResponse;
        });
    }
}

export class AxiosRestApplicationClient extends RestApplicationClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}
